import $apiPrivate from '@/api/apiPrivate';

const getTickets = async () => {
  const response = await $apiPrivate.get('support/tickets');
  return response;
};

const getTicketTopics = async () => {
  const response = await $apiPrivate.get('support/topics');
  return response;
};

const addTicket = async formData => {
  const response = await $apiPrivate.post('support/tickets', formData);
  return response;
};

const getTicket = async id => {
  const response = await $apiPrivate.get(`support/tickets/${id}`);
  return response;
};

const addMessage = async ({ id, formData }) => {
  const response = await $apiPrivate.post(
    `support/tickets/${id}/messages`,
    formData,
  );
  return response;
};

const getUnreadTickets = async () => {
  const response = await $apiPrivate.get('support/unread_messages_count');
  return response;
};

export default {
  getTickets,
  getTicketTopics,
  addTicket,
  getTicket,
  addMessage,
  getUnreadTickets,
};
